import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const Svg = styled.svg`
  position: absolute;
`;

const LoyaltyLockIcon = ({
  color = 'currentColor',
  width = '30',
  height = '24',
  ...rest
}) => {
  return (
    <Svg
      viewBox="0 0 30 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
    >
      <path
        d="M13.9952 17.2712L13.9962 16.1276C13.399 15.8159 12.9979 15.2322 12.9985 14.5645C12.9993 13.5679 13.8946 12.7598 14.998 12.7597C16.1014 12.7595 16.9954 13.5674 16.9946 14.564C16.994 15.2317 16.5919 15.8151 15.9947 16.1269L15.9933 17.271C15.9929 17.7695 15.545 18.1734 14.9935 18.1734C14.4421 18.1735 13.9948 17.7698 13.9952 17.2712ZM9.00684 9.15115L8.1147 9.16704C7.56174 9.1671 7.00844 9.57274 7.00793 10.1804L6.99952 20.3186C6.99909 20.8257 7.55164 21.3323 8.1046 21.3322L21.8772 21.3307C22.5405 21.3306 22.9835 20.8239 22.984 20.3169L22.9924 10.1787C22.9929 9.57098 22.5506 9.16545 21.8873 9.16552L11.5044 9.15087L9.00684 9.15115Z"
        fill={color}
      />
      <path
        d="M10.5082 9.48853L10.482 6.80392C10.4601 4.56103 12.4547 2.72601 14.9375 2.70485C17.4203 2.68369 19.4504 4.4844 19.4722 6.72729L19.4984 9.4119"
        stroke={color}
        strokeWidth="2.26147"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </Svg>
  );
};

LoyaltyLockIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default LoyaltyLockIcon;
